var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebok",
    transform: "translate(-12.374 1.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(12.374 -1.001)",
    fill: "#cee8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_11_",
    d: "M32.279,23.549H29.062c-.506,0-.687-.169-.687-.641q0-1.819,0-3.639c0-.466.191-.644.691-.644h3.213c0-.083,0-1.834,0-2.641a6.2,6.2,0,0,1,.884-3.378,5.291,5.291,0,0,1,2.891-2.226A7.658,7.658,0,0,1,38.53,10q1.592,0,3.183,0c.456,0,.658.187.659.613q0,1.711,0,3.422c0,.43-.195.6-.661.608-.87.009-1.74,0-2.609.036-.878,0-1.339.4-1.339,1.239-.021.89-.009,1.782-.009,2.7H41.5c.53,0,.711.169.711.663q0,1.809,0,3.619c0,.487-.171.642-.7.643H37.744v9.763c0,.521-.177.686-.731.686H32.96c-.49,0-.681-.176-.681-.63,0-3.18,0-9.708,0-9.82Z",
    transform: "translate(0 0)",
    fill: "#457186"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.1815e54b1b2102fc53dc9ca51a3aa265.svg";
export { ForwardRef as ReactComponent };